// extracted by mini-css-extract-plugin
export default {"image":"Tile_image__UVdWR","title":"Tile_title__lBuHG","circle":"Tile_circle__h4Sr8","icon":"Tile_icon__9tCwk","container":"Tile_container__skLrr"};